var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCDcourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49219 15.3504L13.6159 22.0769C13.7809 22.1684 13.8633 22.2142 13.9499 22.2322C14.0265 22.2482 14.1051 22.2482 14.1817 22.2322C14.2682 22.2142 14.3507 22.1684 14.5156 22.0769L26.6394 15.3504M1.49219 22.3265L13.6159 29.0531C13.7809 29.1446 13.8633 29.1903 13.9499 29.2083C14.0265 29.2243 14.1051 29.2243 14.1817 29.2083C14.2682 29.1903 14.3507 29.1446 14.5156 29.0531L26.6394 22.3265M1.49219 8.37426L13.6159 1.64771C13.7809 1.5562 13.8633 1.51044 13.9499 1.49243C14.0265 1.47648 14.1051 1.47648 14.1817 1.49243C14.2682 1.51044 14.3507 1.5562 14.5156 1.64771L26.6394 8.37426L14.5156 15.1008C14.3507 15.1923 14.2682 15.2381 14.1817 15.2561C14.1051 15.272 14.0265 15.272 13.9499 15.2561C13.8633 15.2381 13.7809 15.1923 13.6159 15.1008L1.49219 8.37426Z",
    stroke: "#1DBF73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCDcourse);
export default __webpack_public_path__ + "static/media/CDcourse.2d74d9574536f5144c15f460e333a0e5.svg";
export { ForwardRef as ReactComponent };